import { useEffect, useState } from "react";

interface ToastProps {
  type: "success" | "error";
  message: string;
  onClose: () => void;
}

export default function Toast({ type, message, onClose }: ToastProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Entrada con animación
    const showTimer = setTimeout(() => setVisible(true), 10);
    // Auto-cierre tras 5 segundos
    const closeTimer = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 400);
    }, 5000);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(closeTimer);
    };
  }, [onClose]);

  const isSuccess = type === "success";

  return (
    <div
      className={`fixed bottom-6 left-1/2 z-[9999] transition-all duration-400 ${
        visible ? "opacity-100 translate-y-0 -translate-x-1/2" : "opacity-0 translate-y-6 -translate-x-1/2"
      }`}
    >
      <div className={`flex items-center gap-4 px-5 py-4 rounded-2xl min-w-[300px] max-w-[90vw] ${
        isSuccess
          ? "bg-green-500 text-white"
          : "bg-red-500 text-white"
      }`}>
        {/* Icono */}
        <div className="w-9 h-9 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
          <i className={`${isSuccess ? "ri-check-line" : "ri-error-warning-line"} text-white text-lg`}></i>
        </div>

        {/* Texto */}
        <p className="text-sm font-semibold flex-1">{message}</p>

        {/* Cerrar */}
        <button
          onClick={() => { setVisible(false); setTimeout(onClose, 400); }}
          className="w-7 h-7 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-all cursor-pointer flex-shrink-0"
        >
          <i className="ri-close-line text-white text-sm"></i>
        </button>
      </div>

      {/* Barra de progreso */}
      <div className={`h-1 rounded-full mt-1 mx-1 ${isSuccess ? "bg-green-300" : "bg-red-300"} overflow-hidden`}>
        <div
          className={`h-full ${isSuccess ? "bg-white/60" : "bg-white/60"} rounded-full`}
          style={{ animation: "shrink 5s linear forwards" }}
        />
      </div>

      <style>{`
        @keyframes shrink {
          from { width: 100%; }
          to { width: 0%; }
        }
      `}</style>
    </div>
  );
}
